"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveParenthesesPipe = void 0;
class RemoveParenthesesPipe {
    transform(value, args) {
        if (value !== null) {
            return value.charAt(0) === '(' ?
                '-' + value.substring(1, value.length - 1) + '' :
                value;
        }
    }
}
exports.RemoveParenthesesPipe = RemoveParenthesesPipe;
//# sourceMappingURL=removeParentheses.pipe.js.map